<ng-container *ngIf="!showDeterminant">
    <span class="btn btn-circle-icon btn-circle-small font-weight-bold {{hasErrors ? 'btn-danger' : 'btn-warning'}} {{regularSpaces ? 'ml-4 mr-2' : ''}} {{extraClasses}}"
        [popover]="hasErrors ? ('This determinant has errors' | translate) : detDetails"
        container="body"
        containerClass="det-popover"
        [placement]="placement"
        triggers="mouseenter mouseleave"
        #pop="bs-popover">D</span>
    <ng-template #detDetails>
        <query-builder
            [jsonString]="determinant"
            [easyToRead]="true"
            [noneSelectedText]="noneSelectedText"
            [determinantMapById]="determinantMapById"
            [readOnly]="true"></query-builder>
    </ng-template>
</ng-container>
<ng-container *ngIf="showDeterminant">
    <div class="d-flex align-items-center">
        <query-builder  *ngIf="!hasErrors" class="d-flex align-items-baseline determinant-element-container px-3 py-1 flex-column"
            [jsonString]="determinant"
            [easyToRead]="true"
            [noneSelectedText]="noneSelectedText"
            [determinantMapById]="determinantMapById"
            [readOnly]="true"></query-builder>
        <span [popover]="hasErrors ? ('This determinant has errors' | translate) : detDetails2" container="body"
            containerClass="det-popover"
            [placement]="placement"
            triggers="mouseenter mouseleave"
            #pop="bs-popover" class="btn btn-circle-icon btn-circle-small font-weight-bold {{hasErrors ? 'btn-danger' : 'btn-warning'}} ml-2 mr-2 {{extraClasses}}">D</span>
        <ng-template #detDetails2>
            <div>{{"Add/Edit determinant" | translate}}</div>
        </ng-template>
    </div>
</ng-container>